const Events = {
  onCloseModalPress: 'onCloseModalPress',
};

export default Events;
